import AppControllerSportsbook from 'applications/sports/app/index.js';
import MainApp from 'applications/common/components/main-app/index.js';
import preBuiltAnalyticsListener from 'applications/sports/analytics/prebuilt-analytics-listener.js';
import { useEffect } from 'react';

export default function MainSportsbook() {
    useEffect(() => {
        initAnalytics();
        return () => {
            disposeAnalytics();
        };
    }, []);

    return <MainApp>{location => <AppControllerSportsbook location={location} />}</MainApp>;
}

const fetchAnalyticsListener = () => {
    return import(
        /* webpackChunkName: "analytics-listener" */ 'applications/sports/analytics/analytics-listener.js'
    ).then(module => module.default);
};

const initAnalytics = () => {
    fetchAnalyticsListener().then(listener => listener.init());
    preBuiltAnalyticsListener.init();
};

const disposeAnalytics = () => {
    fetchAnalyticsListener().then(listener => listener.dispose());
    preBuiltAnalyticsListener.dispose();
};
